// reducers/reviewReducer.js
import {
    FETCH_REVIEWS_REQUEST,
    FETCH_REVIEWS_SUCCESS,
    FETCH_REVIEWS_FAILURE,
  } from '../actions/types';
  
  const initialState = {
    reviews: [],
    loading: false,
    error: null,
    message: '',
  };
  
  // Reducer for handling review actions
  export default function reviewReducer(state = initialState, action) {
    switch (action.type) {
      case FETCH_REVIEWS_REQUEST:
        return { ...state, loading: true, error: null };
  
      case FETCH_REVIEWS_SUCCESS:
        return {
          ...state,
          loading: false,
          reviews: action.payload,
          message: 'Reviews loaded successfully',
        };
  
      case FETCH_REVIEWS_FAILURE:
        return {
          ...state,
          loading: false,
          error: action.payload,
          reviews: [],
        };
  
      default:
        return state;
    }
  }
  